import React, { Component, Fragment } from "react";
import ReactHtmlParser from "react-html-parser";

class IconBlock extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { icon } = this.props;

    return (
      <Fragment>
        <article className="icon_block">
          {icon.lxl_iconblock_icon && (
            <div className="image_container">
              <img
                src={icon.lxl_iconblock_icon.url}
                alt=""
                role="presentation"
              />
            </div>
          )}
          {icon.lxl_iconblock_copy && (
            <p className="content_container">
              {ReactHtmlParser(icon.lxl_iconblock_copy)}
            </p>
          )}
        </article>
      </Fragment>
    );
  }
}

export default IconBlock;
